import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, LL_H_C, LL_V_L, ModuleFE_Dialog, performAction, SimpleListAdapter, TS_DropDown, TS_Input, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { _keys, BadImplementationException, cloneObj, dbObjectToId, filterDuplicates, functionThatReturnsFalse } from '@nu-art/ts-common';
import { Component_TagEditor, ConfigKeyFE_DiseasesViewsTagId, handleError, HCSDropDowns, ModuleFE_Tag } from '@app/hcs-frontend';
import { ICONS } from '@app/styles';
import { cleanDPView, dpViewTypes } from '@app/dp-shared';
import { ModuleFE_DiseaseView } from '../../../_entity.js';
export class Dialog_ViewConfigEditor extends ComponentSync {
    // ######################## Static ########################
    static show(_view) {
        const view = _view ? cloneObj(_view) : cloneObj(cleanDPView);
        //TODO: this is a correction for views that don't have enforced tags yet, remove eventually
        if (!view.enforcedTags)
            view.enforcedTags = [];
        return ModuleFE_Dialog.show({ content: _jsx(Dialog_ViewConfigEditor, { view: view }), closeOverlayOnClick: functionThatReturnsFalse });
    }
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps) {
        const state = this.state ? { ...this.state } : {};
        const dvTagId = ConfigKeyFE_DiseasesViewsTagId.get();
        state.viewTagsIds ||= ModuleFE_Tag.cache.filter(item => item.tagIds.includes(dvTagId)).map(dbObjectToId);
        this.fixViewFilter(nextProps.view);
        state.whitelist ||= this.convertTagListToTagGroup(nextProps.view.filter.tagIds.whitelist);
        state.blacklist ||= this.convertTagListToTagGroup(nextProps.view.filter.tagIds.blacklist);
        return state;
    }
    // ######################## Logic ########################
    saveView = async () => {
        const title = (this.props.view._id ? 'Updating' : 'Creating') + ' View Config';
        await performAction(async () => {
            this.setState({ dialogIsBusy: true });
            const whitelist = this.convertTagGroupToTagList(this.state.whitelist);
            const blacklist = this.convertTagGroupToTagList(this.state.blacklist);
            this.props.view.filter.tagIds = { whitelist, blacklist };
            try {
                await ModuleFE_DiseaseView.v1.upsert(this.props.view).executeSync();
            }
            catch (e) {
                handleError(e);
            }
            ModuleFE_Dialog.close();
        }, { type: 'notification', notificationLabels: title });
        if (this.mounted)
            this.setState({ dialogIsBusy: false });
    };
    deleteView = async () => {
        this.setState({ dialogIsBusy: true });
        await performAction(async () => {
            await ModuleFE_DiseaseView.v1.delete(this.props.view).executeSync();
            ModuleFE_Dialog.close();
        }, { type: 'notification', notificationLabels: 'Deleting View Config' });
        if (this.mounted)
            this.setState({ dialogIsBusy: false });
    };
    fixViewFilter(view) {
        if (!view.filter)
            view.filter = { tagIds: {} };
        if (!view.filter.tagIds)
            view.filter.tagIds = {};
        if (!view.filter.tagIds.whitelist)
            view.filter.tagIds.whitelist = [];
        if (!view.filter.tagIds.blacklist)
            view.filter.tagIds.blacklist = [];
    }
    convertTagListToTagGroup(tagList) {
        const map = tagList.reduce((acc, tagId) => {
            const tag = ModuleFE_Tag.cache.unique(tagId);
            if (!tag)
                throw new BadImplementationException(`Could not find tag for id ${tagId}`);
            if (!acc[tag.tagIds[0]])
                acc[tag.tagIds[0]] = [];
            acc[tag.tagIds[0]].push(tag);
            return acc;
        }, {});
        return _keys(map).reduce((acc, key) => {
            const tag = ModuleFE_Tag.cache.unique(key);
            if (!tag)
                throw new BadImplementationException(`Could not find tag for id ${key}`);
            acc.push({ key: tag, value: map[key] });
            return acc;
        }, []);
    }
    convertTagGroupToTagList(tagGroup) {
        return tagGroup.reduce((acc, group) => {
            const tagIds = group.value.map(tag => tag._id);
            acc.push(...tagIds);
            return filterDuplicates(acc);
        }, []);
    }
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { className: 'dialog', children: [this.renderHeader(), this.renderMain(), this.renderButtons()] });
    }
    renderHeader() {
        return _jsxs(LL_H_C, { className: "dialog__header", children: [_jsx("span", { className: "title-text", children: (this.props.view._id ? 'Edit' : 'Add') + 'View' + ` - ${this.props.view.label}` }), _jsx(ICONS.x.component, { className: "exit_icon", onClick: () => ModuleFE_Dialog.close() })] });
    }
    renderDeleteButton() {
        if (!this.props.view._id)
            return '';
        return _jsx(Button, { variant: 'dangerous', onClick: this.deleteView, disabled: this.state.dialogIsBusy, className: 'delete-button', children: "Delete" });
    }
    renderButtons() {
        return _jsxs(LL_H_C, { className: "dialog__buttons", children: [this.renderDeleteButton(), _jsx(Button, { variant: 'secondary', onClick: () => ModuleFE_Dialog.close(), children: "Cancel" }), _jsx(Button, { variant: 'primary', onClick: this.saveView, disabled: this.state.dialogIsBusy, className: 'desired-action-button', children: "Save" })] });
    }
    // ######################## Render - Main ########################
    renderMain() {
        return _jsxs(LL_H_C, { className: 'dialog__main', style: { gap: '16px' }, children: [_jsxs(LL_V_L, { className: 'dialog__main__section', children: [this.renderLabel(), this.renderWhitelist()] }), _jsxs(LL_V_L, { className: 'dialog__main__section', children: [this.renderType(), this.renderEnforcedTags(), this.renderBlacklist()] })] });
    }
    renderLabel() {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Label', className: 'match_width', children: _jsx(TS_Input, { type: 'text', value: this.props.view.label, onChange: val => {
                    this.props.view.label = val;
                    this.forceUpdate();
                } }) });
    }
    renderType() {
        const adapter = SimpleListAdapter([...dpViewTypes], item => _jsx("div", { className: 'node-data', children: item.item }));
        return _jsx(TS_PropRenderer.Vertical, { label: 'Type', className: 'match_width', children: _jsx(TS_DropDown, { adapter: adapter, selected: this.props.view.type, onSelected: val => {
                    this.props.view.type = val;
                    this.forceUpdate();
                } }) });
    }
    renderEnforcedTags() {
        return _jsx(TS_PropRenderer.Vertical, { label: 'Enforced Tag', className: 'match_width', children: _jsx(HCSDropDowns.Tag, { className: 'tag-dropdown', queryFilter: item => this.state.viewTagsIds.includes(item._id), selected: this.props.view.enforcedTags[0], onSelected: tag => {
                    this.props.view.enforcedTags[0] = tag._id;
                    this.forceUpdate();
                } }) });
    }
    renderWhitelist() {
        return _jsx(TS_PropRenderer.Vertical, { className: 'match_width', label: 'Whitelist', children: _jsx(Component_TagEditor, { tags: this.state.whitelist, groupTagFilter: () => true, singleTagFilter: (tag, groupTag) => tag.tagIds[0] === groupTag._id }) });
    }
    renderBlacklist() {
        return _jsx(TS_PropRenderer.Vertical, { className: 'match_width', label: 'Blacklist', children: _jsx(Component_TagEditor, { tags: this.state.blacklist, groupTagFilter: () => true, singleTagFilter: (tag, groupTag) => tag.tagIds[0] === groupTag._id }) });
    }
}
//# sourceMappingURL=Dialog_ViewConfigEditor.js.map